import Page from '@shell/Page'
import Segmented from '@ui/elements/Segmented'
import { SegmentedOption } from '@ui/elements/Segmented/types'
import Typography from '@ui/typography'
import { useState } from 'react'
import { View } from 'react-native'

const allOptions: SegmentedOption<string>[] = [
  { id: 'vf', label: 'Varifocals' },
  { id: 'sv', label: 'Single Vision' },
  { id: 'office', label: 'Office' },
  { id: 'kids', label: 'Kids' },
]

// Same length as `allOptions`, but #3/#4 are replaced with new ids.
const swappedTail: SegmentedOption<string>[] = [
  allOptions[0],
  allOptions[1],
  { id: 'sport', label: 'Sport' },
  { id: 'reading', label: 'Reading' },
]

const swappedMiddle: SegmentedOption<string>[] = [
  allOptions[0],
  { id: 'sport', label: 'Sport' },
  { id: 'reading', label: 'Reading' },
  allOptions[3],
]

type PresetId =
  | 'all'
  | 'three'
  | 'two'
  | 'reversed'
  | 'one'
  | 'swap'
  | 'swap-middle'

const presets: SegmentedOption<PresetId>[] = [
  { id: 'all', label: 'All 4' },
  { id: 'three', label: 'First 3' },
  { id: 'two', label: 'First 2' },
  { id: 'reversed', label: 'Reversed' },
  { id: 'one', label: 'Single' },
  { id: 'swap', label: 'Swap Tail' },
  { id: 'swap-middle', label: 'Swap Middle' },
]

// Module-level so each preset maps to a stable array reference across renders.
const presetToOptions: Record<PresetId, SegmentedOption<string>[]> = {
  all: allOptions,
  three: allOptions.slice(0, 3),
  two: allOptions.slice(0, 2),
  reversed: [...allOptions].reverse(),
  one: allOptions.slice(0, 1),
  swap: swappedTail,
  'swap-middle': swappedMiddle,
}

export default function SegmentedPreview() {
  const [preset, setPreset] = useState<SegmentedOption<PresetId>>(presets[0])
  const [selected, setSelected] = useState<SegmentedOption<string>>(
    allOptions[0]
  )

  const activeOptions = presetToOptions[preset.id]

  // Intentionally NOT reconciling `selected` on preset change, so the option set
  // can shift out from under the current value to test Segmented's own behavior.

  return (
    <Page>
      <View className="gap-16 p-32">
        <View className=" gap-4">
          <Typography variant="XS" className="uppercase text-black/50">
            Component under test
          </Typography>
          <View className="w-max self-center">
            <Segmented
              options={activeOptions}
              value={selected}
              onChange={setSelected}
            />
          </View>
        </View>

        <View className="gap-4">
          <Typography variant="XS" className="uppercase text-black/50">
            Option set
          </Typography>
          <Segmented options={presets} value={preset} onChange={setPreset} />
        </View>
      </View>
    </Page>
  )
}
